import axios from 'axios';
import { useAppStore } from '@/store/app';
import { $t } from '@/i18n';
import { useAlertStore } from './store/alerts';

export const http = axios.create({
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

http.interceptors.request.use(config => {
  const app = useAppStore();
  app.loading++;
  return config;
});

http.interceptors.response.use(
  response => {
    const app = useAppStore();
    app.loading--;

    if (response.data?.message) {
      const type = response.data.level || 'info';
      const alertStore = useAlertStore();
      alertStore.add({ title: response.data.message, type, toast: true });
    }

    return response;
  },

  error => {
    const alertStore = useAlertStore();
    const app = useAppStore();
    app.loading--;

    if (error.response) {
      const code = error.response.status;
      const data = error.response.data || {};
      let message: string | undefined = '';
      if (typeof data === 'string') {
        if (data.substring(0, 1) !== '<') {
          message = data;
        }
      } else {
        message = data.message || data.reason || data.description;
      }
      if (code === 401) {
        if (app.route()?.meta.requiresAuth) {
          app.logout(true);
        }
      } else if (code == 403 && typeof data === 'object' && data.code == 10) {
        alertStore.add({ title: $t('Utente non autorizzato'), type: 'warning', toast: true });
      } else if (code === 413) {
        alertStore.add({ title: $t('Il file caricato è troppo grande.'), type: 'warning', toast: true });
      } else if (code >= 400 && code < 500 && message) {
        alertStore.add({ title: message, type: [400, 409, 422].includes(code) ? 'warning' : 'danger', toast: true });
      } else if (code == 503) {
        app.maintenance = true;
      } else if (code >= 500) {
        alertStore.add({ title: error.response.statusText || $t("Errore non previsto. Invia una mail a support{'@'}artera.net per assistenza."), type: 'danger', toast: true });
      }
    }
    return Promise.reject(error);
  },
);
